import { Languages } from "lucide-react";

/**
 * Compact language picker — pill-style segmented control.
 * Used on /evaluate, /builder, /templates, and Results revised-CV download.
 *
 * Output: writes back the ISO 639-1 code ("en", "es", "de", "fr").
 *
 * Props:
 *   value     — current language code
 *   onChange  — (code) => void
 *   label     — optional override (defaults to "Output language")
 *   testIdPrefix — string used to build data-testid (e.g. "evaluate-lang")
 *   className — pass-through for outer wrapper
 */
const LANGS = [
  { code: "en", label: "EN", native: "English" },
  { code: "es", label: "ES", native: "Español" },
  { code: "de", label: "DE", native: "Deutsch" },
  { code: "fr", label: "FR", native: "Français" },
];

export default function LanguagePicker({ value = "en", onChange, label = "Output language", testIdPrefix = "lang", className = "" }) {
  return (
    <div className={className} data-testid={`${testIdPrefix}-picker`}>
      <div className="flex items-center gap-2 mb-2 text-sm font-medium text-zinc-700">
        <Languages className="h-4 w-4 text-zinc-500" />
        <span>{label}</span>
      </div>
      <div className="inline-flex rounded-full border border-zinc-300 bg-white p-1 gap-1">
        {LANGS.map((l) => {
          const active = (value || "en").toLowerCase() === l.code;
          return (
            <button
              key={l.code}
              type="button"
              onClick={() => onChange?.(l.code)}
              data-testid={`${testIdPrefix}-${l.code}`}
              title={l.native}
              className={`px-3.5 py-1.5 text-xs font-semibold rounded-full transition-colors ${
                active
                  ? "bg-zinc-900 text-white shadow-sm"
                  : "text-zinc-600 hover:text-zinc-900"
              }`}
            >
              {l.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
